import { Fragment, h } from "preact";
import { observer } from "mobx-react";
import FieldError from "./FieldError";
import PreactTooltip from "./PreactTooltip";
function CheckboxField(props) {
    const { controller, name, label, helpText, children, required = true, disabled = false, dataFieldId, } = props;
    const handleChange = (event) => {
        const checked = event.target.checked;
        controller.change(checked);
    };
    const hasError = (controller.isTouched && controller.isInvalid) ||
        (controller.isTouched && required && !controller.value);
    const hasHelpText = helpText !== undefined;
    const hasChildren = children !== undefined;
    return (h("div", { class: `boolean input checkbox form-group ${hasError ? "has-error" : ""}`, "data-field-id": dataFieldId },
        h("label", { class: `m-checkbox ${required ? "m-form__label--required" : ""} ${disabled ? "is-disabled" : ""}`, htmlFor: name },
            h("input", { name: name, id: name, type: "checkbox", class: "m-checkbox__input", checked: controller.value, onChange: handleChange, onBlur: () => controller.blur(), required: required, disabled: disabled }),
            h("i", { class: "m-checkbox__icon-state", "aria-hidden": "true" }),
            label,
            hasHelpText && (h(PreactTooltip, { title: helpText },
                h("i", { class: "icon-help-circled" }))),
            hasChildren && h(Fragment, null, children)),
        hasError && h(FieldError, { errors: controller.errors })));
}
export default observer(CheckboxField);
